import axios from '../../../axios_config';
import { notification } from 'antd';

export const getDimensions = ({ asin }) => (dispatch) => {
  dispatch({ type: 'FETCH_DIMENSIONS_REQUEST' });

  return axios({
    method: 'GET',
    url: `/api/v2/vendor_asins/dimensions?asin=${asin}`
  })
    .then(({ data }) => {
      const { success, dimensions } = data || {};
      if (success) return dispatch({ type: 'FETCH_DIMENSIONS_SUCCESS', payload: { dimensions } });

      notification.error({
        message: 'FETCH DIMENSIONS',
        description: 'Failed To Fetch Dimensions',
        top: 65
      });
      return dispatch({ type: 'FETCH_DIMENSIONS_FAILED' });
    })
    .catch((error) => {
      if (axios.isCancel(error)) return;

      const { response } = error || {};
      const { data } = response || {};
      const { message } = data || {};

      notification.error({
        message: 'FETCH DIMENSIONS',
        description: message || error.message,
        top: 65
      });
      return dispatch({ type: 'FETCH_DIMENSIONS_FAILED' });
    });
};
